import type { FC } from "react";
import { cn } from "utils";

interface IntroHeadlineProps {
  prefix?: string;
  accent?: string;
  suffix?: string;
  /** Single-line headline when no accent split */
  text?: string;
  className?: string;
}

export const IntroHeadline: FC<IntroHeadlineProps> = ({
  prefix,
  accent,
  suffix,
  text,
  className,
}) => {
  if (text) {
    return (
      <h1
        data-testid="intro-headline"
        className={cn(
          "headline_regular_xl md:display_s text-content_inverse_primary whitespace-pre-wrap break-words",
          className,
        )}
      >
        {text}
      </h1>
    );
  }

  return (
    <h1
      data-testid="intro-headline"
      className={cn(
        "headline_regular_xl md:display_s text-content_inverse_primary whitespace-pre-wrap break-words",
        className,
      )}
    >
      {prefix}
      {accent ? (
        <span className="text-content_inverse_primary">{accent}</span>
      ) : null}
      {suffix}
    </h1>
  );
};
